import { ChipProps, Chip as MuiChip, styled as styledMui } from '@mui/material';
import { styled } from 'styled-components';

import { AttachmentMode } from '../../../models/attachment';
import devices from '../../../styles/devices';

import FileIcon from '../../Common/FileIcon';

import { Wrapper as RibbonWrapper } from './AttachmentRibbon/styled';

type WrapperProps = Partial<ChipProps> & { 'data-mode': AttachmentMode };

/**
 * Get styles for current mode
 *
 * @param props Props passed to the component
 * @returns     Styles for current mode
 */
const getStylesForMode = (props: WrapperProps) => {
  const mode = props['data-mode'];

  if (mode === 'compose') {
    return {
      backgroundColor: 'transparent',
      padding:
        'calc(var(--spacing-small) + var(--spacing-tiny)) var(--spacing-big)',
      width: '100%',
      [`@media ${devices.tabletS}`]: {
        backgroundColor: 'var(--color-background)',
        padding: 'var(--spacing-small) var(--spacing-medium)',
      },
    };
  }

  if (mode === 'detailsEdit') {
    return { width: '100%' };
  }

  return {
    width: '160px',

    [`@media ${devices.tabletS}`]: { width: '180px' },
  };
};

export const Icon = styled(FileIcon)`
  flex-shrink: 0;
`;

export const Wrapper = styled.div`
  position: relative;

  &:hover ${RibbonWrapper} {
    display: flex;
  }
`;

export const Chip = styledMui(MuiChip)<WrapperProps>(props => ({
  '& .MuiChip-label': {
    flexGrow: 1,
    marginLeft: 'var(--spacing-tiny)',
    padding: 0,
  },

  alignItems: 'center',
  backgroundColor: 'var(--color-background)',
  border: 'var(--border-dark)',
  borderRadius: 'var(--border-radius-medium)',
  display: 'inline-grid',
  gridTemplateColumns: 'auto 1fr auto',
  height: 'fit-content',
  justifyContent: 'flex-start',
  padding: 'var(--spacing-small) var(--spacing-medium)',
  userSelect: 'none',
  ...getStylesForMode(props),
}));
